import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/bank/`;

const getBanks = async () => {
    return await axios.get(API_URL);
};

const addBank = async (websiteData) => {
    return await axios.post(API_URL, websiteData);
};

const deleteBank = async (websiteId) => {
    return await axios.delete(API_URL + websiteId);
};

const updateBank = async (bankData) => {
    return await axios.put(API_URL, bankData);
};

export default {
    getBanks,
    addBank,
    deleteBank,
    updateBank
};
